import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/app/(with-header-footer)/triallist/trials.module.css");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/ad-trial/ad-trial.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/share-social/share-social.tsx");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/title/title.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trials/filter/filter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trials/list/list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trials/padination/pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trials/trial-per-page/trial-per-page.tsx");
